var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlyqualifiednurses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9644 31.7638C28.7357 31.7638 35.8463 24.6532 35.8463 15.8819C35.8463 7.11056 28.7357 0 19.9644 0C11.1931 0 4.08252 7.11056 4.08252 15.8819C4.08252 24.6532 11.1931 31.7638 19.9644 31.7638Z",
    fill: "#FFD15C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09836 25.1719L1.63379 34.6443L8.01174 34.3057L10.9094 39.9986L15.9645 31.2349C12.3425 30.2979 9.23221 28.1168 7.09836 25.1719Z",
    fill: "#40596B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8621 25.125C30.7439 28.0778 27.6337 30.2667 24.0195 31.2195L29.0904 39.999L31.988 34.3061L38.366 34.6447L32.8621 25.125Z",
    fill: "#40596B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9644 27.3928C26.3222 27.3928 31.4763 22.2387 31.4763 15.881C31.4763 9.52315 26.3222 4.36914 19.9644 4.36914C13.6067 4.36914 8.45264 9.52315 8.45264 15.881C8.45264 22.2387 13.6067 27.3928 19.9644 27.3928Z",
    fill: "#F8B64C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8542 14.6384C28.2085 14.292 28.0117 13.6857 27.5235 13.6148L22.9802 12.9534C22.7833 12.9219 22.618 12.8038 22.5314 12.6227L20.4999 8.50458C20.2794 8.05576 19.6416 8.05576 19.4211 8.50458L17.3975 12.6227C17.3109 12.7959 17.1377 12.9219 16.9487 12.9534L12.4054 13.6148C11.9172 13.6857 11.7203 14.292 12.0747 14.6384L15.3581 17.8432C15.4999 17.9849 15.5629 18.1817 15.5314 18.3707L14.7597 22.8904C14.6731 23.3786 15.1928 23.7566 15.6337 23.5203L19.6967 21.3865C19.8699 21.292 20.0825 21.292 20.2558 21.3865L24.3188 23.5203C24.7597 23.7487 25.2715 23.3786 25.1928 22.8904L24.4133 18.3707C24.3818 18.1739 24.4448 17.977 24.5865 17.8432L27.8542 14.6384Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlyqualifiednurses);
export default __webpack_public_path__ + "static/media/Highly qualified nurses.a53bfdcb43b3e80da777511f513ba15a.svg";
export { ForwardRef as ReactComponent };